<template>
    <v-container
        class="ma-0 pa-0"
    >
        <v-row
            no-gutters
        >
            Plan Type: {{mealTimeToEdit.plan_type}}
        </v-row>
        <v-row
            v-if="mealTimeToEdit.plan_type == 'self'"
            no-gutters
        >
            Food Type: {{mealTimeToEdit.food_type}}
        </v-row>
        <v-row
            no-gutters
        >
            Time to Prepare: {{mealTimeToEdit.minutes_available_to_prepare}}
        </v-row>
        <v-row
            no-gutters
        >
            Prepare in Advance: {{mealTimeToEdit.prepare_in_advance}}
        </v-row>
        <v-row
            no-gutters
        >
            Meal Time: {{mealTimeToEdit.time}}
        </v-row>

        <v-row
            no-gutters
        >
            data: {{mealTimeToEdit}}
        </v-row>
        <v-row
            justify="space-between"
            class="mt-5"
            no-gutters
        >
            <v-btn
                color="red"
                class="mt-0 mr-4 white--text"
                @click.prevent="cancel"
            >
                Cancel
            </v-btn>

            <v-btn
                color="blue"
                class="mt-0 white--text"
                @click.prevent="save"
                :disabled="!readyToSave"
            >
                Save
            </v-btn>
        </v-row>
    </v-container>
</template>

<script>
export default {
    data: () => ({
        readyToSave: false,
    }),

    methods: {
        save() {
            console.log('save');
        },
        cancel() {
            this.editMealDialog = false;
            this.$store.dispatch('data/updateMealTimeToEdit',null);
        },
    },

    computed: {
        mealTimeToEdit() {
            let options = this.$store.getters['data/mealTime'];
            let thisOption = this.$store.getters['data/mealTimeToEdit'];
            let response = {}
            let max = options.length;

            for (let i = 0; i < max; i++){
                if (options[i].id == thisOption){
                    response = options[i];
                    i = max;
                }
            }

            return response
        },
        editMealDialog: {
            get(){
                return this.$store.getters['data/editMealDialog'];
            },
            set(value) {
                this.$store.dispatch('data/updateEditMealDialog',value);
            }
        },

    } 
};
</script>
